import { inject, Injectable } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';

@Injectable({ providedIn: 'root' })
export class ImportSkillsCacheService {
  private readonly localStorageService = inject(LocalStorageService);

  private readonly dontShowIntroKey = 'importSkillsIntroDontShowAgain';

  public setDontShowIntroFlag() {
    return this.localStorageService.set(this.dontShowIntroKey, true);
  }

  public getDontShowIntroFlag() {
    return this.localStorageService.get(this.dontShowIntroKey);
  }
}
